var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletsLibraries(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4688 20C67.7961 20 68.8721 21.076 68.8721 22.4033L68.8721 29.6131C68.8721 30.9404 67.7961 32.0164 66.4688 32.0164L18.4034 32.0164C17.0761 32.0164 16.0001 30.9404 16.0001 29.6131L16.0001 22.4033C16.0001 21.076 17.0761 20 18.4034 20L66.4688 20ZM64.0655 24.8065L20.8066 24.8065L20.8066 27.2098L64.0655 27.2098L64.0655 24.8065Z",
    fill: "#222831",
    stroke: "#F9F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 29.6132C16 28.2859 17.076 27.21 18.4033 27.21H71.2753C72.6026 27.21 73.6785 28.2859 73.6785 29.6132V68.0656C73.6785 69.3929 72.6026 70.4689 71.2753 70.4689H18.4033C17.076 70.4689 16 69.3929 16 68.0656V29.6132ZM20.8065 32.0165V65.6623H68.872V32.0165H20.8065Z",
    fill: "#222831",
    stroke: "#F9F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3152 48.8393C63.3152 51.0796 61.4991 52.8958 59.2587 52.8958C57.0183 52.8958 55.2021 51.0796 55.2021 48.8393C55.2021 46.5989 57.0183 44.7827 59.2587 44.7827C61.4991 44.7827 63.3152 46.5989 63.3152 48.8393Z",
    fill: "#BAE047",
    stroke: "#F9F9F9",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletsLibraries);
export default __webpack_public_path__ + "static/media/wallets-libraries.0fa406d2c5fcb80a385a89c09785d18f.svg";
export { ForwardRef as ReactComponent };